export const DEFAULT_DURATION_FOR_TITLE = 3000;
export const DEFAULT_DURATION_FOR_TITLE_AND_DESCRIPTION = 5000;
export const DEFAULT_ERROR_DESCRIPTION =
  "Something went wrong. Please try again later.";
export const SLIDE_ANIMATION_DISTANCE = 50;
